/** @format */

import {styled} from '@mui/material/styles';
import {Link} from '@mui/material';

export const Root = styled(Link)(({theme}) => ({
  height: '32px',
  borderRadius: '8px',
  background: '#3f4a6b',
  color: '#F9FCFE',
  fontSize: '14px',
  fontWeight: 400,
  lineHeight: '16px',
  padding: theme.spacing(0, 4),
  display: 'flex',
  alignItems: 'center',
  cursor: 'pointer',
  gap: theme.spacing(2),
  textDecoration: 'none',
}));
